(function () {
	'use strict';

	angular.module('sempraWebapp').service('getDaysService', getDays);

	/** @ngInject */
	function getDays ($locale) {
		this.getDayList = function() {
			return $locale.DATETIME_FORMATS.DAY;
    };
    this.getShortDayList = function() {
			return $locale.DATETIME_FORMATS.SHORTDAY;
		};
	}
  })();
